import { Navigate, Routes as ReactRouterDOMRoutes, Route } from 'react-router-dom';

import RequireAuth from '@/components/routes/RequireAuth';
import ForgotPassword from '@/pages/auth/ForgotPassword';
import ResetPassword from '@/pages/auth/ResetPassword';
import SignIn from '@/pages/auth/SignIn';
import PatientConsultation from '@/pages/consultations/PatientConsultation';
import Error404 from '@/pages/error/404';
import PatientHelp from '@/pages/help/PatientHelp';
import PatientHome from '@/pages/patient/PatientHome';
import PatientPrescriptions from '@/pages/patient/PatientPrescriptions';
import ProductDetailsPageV2 from '@/pages/products/ProductDetailsPage';
import PatientProfile from '@/pages/profile/PatientProfile';
import { alternaleaf, BrandThemeProvider } from '@montugroup/themes';
import SignOut from '../components/auth/SignOut';
import Refillordersuccess from '../components/layout/RefillOrderSuccess';

import { HelpdeskLayout } from '@/components/layout/helpdesk-layout/HelpdeskLayout';
import MedicineInformation from '@/pages/medicine-information/MedicineInformation';
import PCPortal from '@/pages/pcp/PCPortal';
import { ExternalRedirect } from './ExternalRedirect';
import HealthCheck from './healthCheck';
import {
  ALTERNALEAF_MARKETING,
  CONSULTATIONS_ROUTE,
  DEPRECATED_PATIENT_PRESCRIPTION_ROUTE,
  DEPRECATED_PRESCRIPTION_ROUTE,
  FAQ_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  HEALTH_CHECK_ROUTE,
  HOME_ROUTE,
  LOGIN_ONBOARDKEY_ROUTE,
  LOGIN_PATIENT_ONBOARDKEY_ROUTE,
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  MEDICINE_INFORMATION_ROUTE,
  PATIENT_REFILL_ROUTE,
  POLICY_ROUTE,
  PRE_CONSULT_ROUTE,
  PRESCRIPTIONS_ROUTE,
  PRODUCT_DETAIL_ROUTE,
  PROFILE_DETAILS_ROUTE,
  RESET_PASSWORD_LEGACY_ROUTE,
  RESET_PASSWORD_ROUTE,
  UNUSED_PRESCRIPTION_ROUTE,
} from './route-paths';

function Routes() {
  return (
    <BrandThemeProvider theme={alternaleaf}>
      <ReactRouterDOMRoutes>
        <Route path="/" Component={SignIn} />
        {/* NOTE: Deprecated URL, remove after no longer used by CRM/users */}
        <Route path="/login/patient" element={<Navigate to={{ pathname: LOGIN_ROUTE }} replace />} />
        <Route path={LOGIN_ROUTE} Component={SignIn} />
        {/* NOTE: Deprecated URL, remove after no longer used by CRM/users */}
        <Route path={LOGIN_PATIENT_ONBOARDKEY_ROUTE} Component={SignIn} />
        <Route path={LOGIN_ONBOARDKEY_ROUTE} Component={SignIn} />
        {/* NOTE: Deprecated URL, remove after no longer used by CRM/users */}
        <Route
          path="/forgot-password/patient"
          element={<Navigate to={{ pathname: FORGOT_PASSWORD_ROUTE }} replace />}
        />
        <Route path={FORGOT_PASSWORD_ROUTE} Component={ForgotPassword} />
        <Route path={RESET_PASSWORD_ROUTE} Component={ResetPassword} />
        <Route path={RESET_PASSWORD_LEGACY_ROUTE} Component={ResetPassword} />
        <Route path={HEALTH_CHECK_ROUTE} Component={HealthCheck} />
        <Route path={POLICY_ROUTE} element={<ExternalRedirect to={ALTERNALEAF_MARKETING.PRIVACY_POLICY} />} />
        <Route path={PRE_CONSULT_ROUTE} element={<PCPortal />} />
        <Route element={<RequireAuth />}>
          <Route path={PRODUCT_DETAIL_ROUTE} element={<ProductDetailsPageV2 />} />
          <Route path="/refillordersuccess" element={<Refillordersuccess />} />
          <Route path={LOGOUT_ROUTE} element={<SignOut />} />
          <Route path="/paymentcheckout" element={<Navigate to={PATIENT_REFILL_ROUTE} replace />} />
          <Route element={<HelpdeskLayout />}>
            <Route path={HOME_ROUTE} element={<PatientHome />} />
            <Route path={PROFILE_DETAILS_ROUTE} element={<PatientProfile />} />
            <Route path={MEDICINE_INFORMATION_ROUTE} element={<MedicineInformation />} />
            {/* NOTE: Deprecated URL, remove after no longer used by CRM/users */}
            <Route
              path={DEPRECATED_PATIENT_PRESCRIPTION_ROUTE}
              element={<Navigate to={{ pathname: PRESCRIPTIONS_ROUTE }} replace />}
            />
            {/* NOTE: Deprecated URL, remove after no longer used by CRM/users */}
            <Route
              path={DEPRECATED_PRESCRIPTION_ROUTE}
              element={<Navigate to={{ pathname: PRESCRIPTIONS_ROUTE }} replace />}
            />
            <Route
              path={UNUSED_PRESCRIPTION_ROUTE}
              element={<Navigate to={{ pathname: PRESCRIPTIONS_ROUTE }} replace />}
            />
            <Route path={PRESCRIPTIONS_ROUTE} element={<PatientPrescriptions />} />
            {/* NOTE: Deprecated URL, remove after no longer used by CRM/users */}
            <Route
              path="/patient/consultations"
              element={<Navigate to={{ pathname: CONSULTATIONS_ROUTE }} replace />}
            />
            <Route path={CONSULTATIONS_ROUTE} element={<PatientConsultation />} />
            <Route path={FAQ_ROUTE} element={<PatientHelp />} />
          </Route>
        </Route>
        <Route path="*" Component={Error404} />
      </ReactRouterDOMRoutes>
    </BrandThemeProvider>
  );
}

export default Routes;
